import React, { Component } from 'react';
import { FrameComponent, QuoteWizardComponent } from '../components/views';

class QuotePageLayout extends Component {
  render() {
    return (
      <FrameComponent {...this.props}>
        <QuoteWizardComponent {...this.props} />
      </FrameComponent>
    );
  }
}

export default QuotePageLayout;
